import * as React from "react";

function SvgFloodlight(props, ref) {
  return (
    <svg
      viewBox="0 0 2277.9 2277.9"
      height="1em"
      width="1em"
      {...{ ...props, ref }}
    >
      <g>
        <path
          d="M1541.8,1944.7c-111.2-111.2-111.2-291.6,0-402.9c-222.5,222.5-583.2,222.5-805.7,0
		c111.2,111.2,111.2,291.6,0,402.9c-111.2,111.2-291.6,111.2-402.9,0c444.3,444.3,1167.2,444.3,1611.5,0
		C1833.4,2055.9,1653,2055.9,1541.8,1944.7L1541.8,1944.7z"
          fill="#FBBC04"
        />
        <path
          d="M1944.7,333.2c-444.3-444.3-1167.2-444.3-1611.5,0c-444.3,444.3-444.3,1167.2,0,1611.5
		c-111.2-111.2-111.2-291.6,0-402.9c111.2-111.2,291.6-111.2,402.9,0c-222.5-222.5-222.5-583.2,0-805.7
		c222.5-222.5,583.2-222.5,805.7,0c111.2,111.2,291.6,111.2,402.9,0C2055.9,624.8,2055.9,444.5,1944.7,333.2L1944.7,333.2z"
          fill="#4184F3"
        />
        <circle cx="534.6" cy="1743.2" r="284.9" fill="#34A853" />
        <path
          d="M1944.7,333.2c111.2,111.2,111.2,291.6,0,402.9c-111.2,111.2-291.6,111.2-402.9,0
		c222.5,222.5,222.5,583.2,0,805.7c-111.2,111.2-111.2,291.6,0,402.9c111.2,111.2,291.6,111.2,402.9,0
		C2388.9,1500.4,2388.9,777.5,1944.7,333.2L1944.7,333.2z"
          fill="#EA4335"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgFloodlight);
